<template>
  <div>
    <h4>Anti-Parasitaire</h4>
    
    <data-table
      :data-source="antiParasitaires"
      :headers="headers"
      table-class="table-striped table-hover"
    >
      <template slot="actions">
        <a
          href="javascript:void(0)"
          class="btn btn-outline-primary btn-icon"
          data-toggle="modal"
          data-target="#add-anti-parasitaire"
        >
          <i class="icofont icofont-plus" />
        </a>
      </template>
    </data-table>
        
        
        
    <modal
      title="Ajout d'anti-parasitaire"
      id="add-anti-parasitaire"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="adding"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="add-type">Type de parasite</label>
          <select
            name="add-type"
            id="add-type"
            class="form-control"
            v-model="type"
            v-select="{placeholder: 'Selectionnez le type de parasite'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Ajouter
          </button>
        </div>
      </form>
    </modal>

    <modal
      title="Modification d'anti-parasitaire"
      id="update-anti-parasitaire"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="editing"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="update-type">Type de parasite</label>
          <select
            name="update-type"
            id="update-type"
            class="form-control"
            v-model="type"
            v-select="{placeholder: 'Selectionnez le type de parasite'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import DataTable from '../../../../components/dataTable/local.vue'
import { COMPONENT_TYPE, TEXT_TYPE } from '../../../../components/dataTable/dataType'
import Modal from '../../../../components/modal.vue'
import { ADD_ANTI_PARASITAIRE, UPDATE_ANTI_PARASITAIRE } from '../../../../graphql/sanitaire'
const TypeParasite = () => import('../../../../components/admin/sanitaire/medicament/typeParasiteInline.vue')
const Actions = () => import('../../../../components/admin/sanitaire/medicament/antiParasitaireActions.vue')
export default {
    components: { DataTable, Modal},
    data(){
        return {
            type: null,
            libelle: null,
            has_error: false,
            error_msg: null
        }
    },
    watch: {
        selectedType: {
            handler(){
                if(this.selectedType !== null) {
                    this.libelle = this.selectedType.libelle
                    this.type = this.selectedType.type
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations({
            done: 'DONE',
            setSelectedObject: 'SET_SELECTED_OBJECT'
        }),
        initForm(){
            this.setSelectedObject(null)
            this.libelle = null
            this.has_error = false
            this.error_msg = null
        },
        adding(){
            let data = {
                libelle: this.libelle,
                type: this.type
            }
            this.$apollo.mutate({
                mutation: ADD_ANTI_PARASITAIRE,
                variables: {
                    "medicament": {
                        ...data
                    }
                },
                update: (d) => {
                    console.log(d)
                    console.log(`Type analyse ${this.libelle} add successfully`)
                }
              }).then(() => {
                this.initForm()
                this.done()
            }).catch((error) => {
                console.error(error)
                this.has_error = true
                this.error_msg = error
            })
        },
        editing(){
            let data = {
                libelle: this.libelle,
                type: this.type
            }
            this.$apollo.mutate({
                mutation: UPDATE_ANTI_PARASITAIRE,
                variables: {
                    "medicament": {
                        ...data
                    },
                    "uid": this.selectedType.uid
                },
                update: (d) => {
                    console.log(d)
                    console.log(`Type analyse ${this.libelle} on ${this.selectedType.uid} updated successfully`)
                }
              }).then(() => {
                this.initForm()
                this.done()
            }).catch((error) => {
                console.error(error)
                this.has_error = true
                this.error_msg = error
            })
        }
    },
    computed: {
        ...mapGetters({
            antiParasitaires: 'sanitaire/antiParasitaires',
            types: 'sanitaire/typeParasites',
            selectedType: 'selectedObject'
        }),
        headers(){
            return [
                {label: 'ID', name: 'uid', type: TEXT_TYPE},
                {label: 'Libelle', name: 'libelle', type: TEXT_TYPE},
                {label: 'Type de parasite', name: 'type_parasite', type: COMPONENT_TYPE, component: TypeParasite},
                {label: 'Actions', name: 'action', type: COMPONENT_TYPE, component: Actions}
            ]
        }
    }
}
</script>

<style>

</style>